/*eslint eqeqeq:0 */
define('glu/core/internal/validators',['require','../../util','../../date'],function(require) {
    'use strict';

    var util = require('../../util'),
        moment = require('../../date');

    // Email RegEx
    var html5Spec = '^[a-zA-Z0-9.!#$%&\'*+\\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*',
        tldCheck = '\\.[a-zA-Z0-9-]{0,61}$',
        fullEmailRegEx = new RegExp(html5Spec + tldCheck);

    return {

        exists: function(key, model) {
            var value = model.get(key);

            if (value === void 0 || value === null) {
                return false;
            }

            if (typeof value === 'string') {
                return value.replace(/^\s+|\s+$/gm, '').length > 0;
            } else {
                return true;
            }
        },

        minLength: function(key, min, model) {
            var value = model.get(key);
            if (util.isNumber(value)) {
                value = '' + value;
            }
            return value && (value.length >= (min || 0));
        },

        maxLength: function(key, max, model) {
            var value = model.get(key);
            if (util.isNumber(value)) {
                value = '' + value;
            }
            return !value || (value.length <= (max || 0));
        },

        rangeLength: function(key, range, model) {
            return (this.minLength(key, range[0], model) &&
                this.maxLength(key, range[1], model));
        },

        minValue: function(key, min, model) {
            var value = model.get(key);
            return value && (value >= (min || 0));
        },

        maxValue: function(key, min, model) {
            var value = model.get(key);
            return value && (value <= (min || 0));
        },

        range: function(key, range, model) {
            return (this.minValue(key, range[0], model) &&
                this.maxValue(key, range[1], model));
        },

        oneOf: function(key, searchValues, model) {
            return util.contains(searchValues, model.get(key));
        },

        equalTo: function(key, test, model) {
            return model.get(key) == test;
        },

        contains: function(key, searchPattern, model) {
            var value = model.get(key);
            return value && (value.indexOf(searchPattern) > -1);
        },

        beginsWith: function(key, searchPattern, model) {
            var value = model.get(key);
            return value && (value.indexOf(searchPattern) === 0);
        },

        endsWith: function(key, searchPattern, model) {
            var value = model.get(key);
            return value && (value.indexOf(searchPattern, value.length - searchPattern.length) > -1);
        },

        matches: function(key, pattern, model) {
            var value = model.get(key),
                regEx = new RegExp(pattern);
            if (util.isEmpty(value)) {
                return true;
            }
            return regEx.test(value);
        },

        isNumeric: function(key, model) {
            var value = model.get(key);
            if (util.isString(value) && value !== '') {
                value = +value;
            }
            return !isNaN(value) && util.isNumber(value);
        },

        // Compares the value of one field with another.
        // Useful for confirm password validations.
        sameValue: function(key, key2, model) {
            // only run if both values have been provided.
            // assumes the exists validation will handle
            // the case where values are not provided.
            if (model.get(key) && model.get(key2)) {
                return model.get(key) === model.get(key2);
            }

            return true;
        },

        // Compares the value of one field with another.
        notSameValue: function(key, key2, model) {
            // only run if both values have been provided.
            // assumes the exists validation will handle
            // the case where values are not provided.
            if (model.get(key) && model.get(key2)) {
                return model.get(key) !== model.get(key2);
            }

            return true;
        },

        //Compares the value of one field against all others
        isUnique: function(key, model) {
            /*
             *   returns false when an identical value is found
             *   skips checking against itself
             *   confirms a value has been provided
             *   breaks out of the loop on the first match
             */
            var isUnique = true;
            var attribute;
            if (model.get(key)) {
                for (attribute in model.attributes) {
                    if (key !== attribute) {
                        if (model.get(key) === model.get(attribute)) {
                            isUnique = false;
                            break;
                        }
                    }
                }
            }
            return isUnique;
        },

        isEmailAddress: function(key, model) {
            var value = model.get(key);
            return !!(value && fullEmailRegEx.test(value));
        },

        isGreaterThan: function(key, comparator, model) {
            var value = +model.get(key);

            if (!util.isNumber(comparator) && !util.isNaN(comparator)) {
                comparator = model.get(comparator);
            }

            return value && (value > +comparator);
        },

        isLessThan: function(key, comparator, model) {
            var value = +model.get(key);

            if (!util.isNumber(comparator) && !util.isNaN(comparator)) {
                comparator = model.get(comparator);
            }

            return value && (value < +comparator);
        },

        matchesDatePattern: function(key, pattern, model) {
            if (util.isEmpty(model.get(key))) {
                return true;
            }
            if (util.isFunction(pattern)) {
                pattern = pattern().toUpperCase();
            } else if (util.isString(pattern)) {
                pattern = pattern.toUpperCase();
            } else {
                pattern = 'MM/DD/YYYY';
            }

            //added true flag to force isValid to validate pattern exactly and not ignore separators.
            var d = moment(model.get(key), pattern, true);
            return d.isValid();
        }
    };
});

